export default __webpack_public_path__ + "static/media/AboutCard1.0de535df.png";